import { Button } from '@fiverr-private/fit';
import withClick from '../helpers/withClick';

export default withClick(Button);
